import type { ConfigurationId, WorkingConfigurationId, ProductId, ProductVersionId } from './ids';

export interface ValidationIssue {
  code: string;
  message: string;
  severity: 'info' | 'warning' | 'error';
  targets?: string[];
  domain?: 'business' | 'visual' | 'pricing';
}

export interface ConfigurationStatus {
  complete: boolean;
  valid: boolean;
  issues: ValidationIssue[];
}

export interface ConfigurationState {
  configurationId?: ConfigurationId;
  workingConfigurationId: WorkingConfigurationId;
  revision: number;
  productId: ProductId;
  productVersionId?: ProductVersionId;
  selections: Record<string, unknown>;
  derived?: Record<string, unknown>;
  status: ConfigurationStatus;
  lastActionType?: string;
  updatedAt: string;
}
